import { Link } from "react-router-dom";
import { ArrowRight, LucideIcon } from "lucide-react";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  link: string;
  linkText: string;
  delay?: number;
}

const ServiceCard = ({ icon: Icon, title, description, link, linkText, delay = 0 }: ServiceCardProps) => (
  <div
    className="group ttk-card ttk-service-card rounded-2xl p-6 transition-all duration-300 reveal-up"
    style={{ animationDelay: `${delay}s` }}
  >
    <div className="w-12 h-12 rounded-xl ttk-icon-badge flex items-center justify-center mb-5">
      <Icon className="w-6 h-6 text-primary-foreground" />
    </div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-sm text-muted-foreground mb-5 leading-6">{description}</p>
    <Link
      to={link}
      className="inline-flex items-center gap-2 text-sm font-semibold text-foreground hover:text-primary transition-all ttk-service-link"
    >
      {linkText} <ArrowRight className="w-4 h-4" />
    </Link>
  </div>
);

export default ServiceCard;
